export default __webpack_public_path__ + "media/zurb/img/events/wired/rebuilding/rebuilding-img3-161c7121a37c5e0df1bb398ca1b9ca18.jpg";